/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { env, Native } from '@hb/hbridge';
import { getBenifitsInReopen, getRedirectUrl } from '@/api/vip';
import { Navigator } from '@hb/h5-navigator';
import { VIP_BIZ } from '../const/vip';
import { getTokenAndLocation } from './index';
import { getSystemCode } from './systemCode';
import { ParamsUtil } from './params';

export function getVipBiz(v) {
  if (!v) {
    return null;
  }
  if (config.env === 'fat' || config.env === 'dev') {
    return ({
      Hello0073: VIP_BIZ.BIKE,
      'MAP-Hello0065': VIP_BIZ.TAXI,
      Hello0069: VIP_BIZ.HITCH,
      Hello0006: VIP_BIZ.TRAIN,
      Hello0003: VIP_BIZ.HOTEL,
      Hello0007: VIP_BIZ.SCENE,
      Hello0008: VIP_BIZ.RENT,
      Hello0011: VIP_BIZ.QUICK_SEND,
      Hello0125: VIP_BIZ.GAS,
      Hello0124: VIP_BIZ.GOODS,
      Hello0063: VIP_BIZ.BATTERY,
      Hello0082: VIP_BIZ.FINANCIAL, // 金融业务线
    })[v] || null;
  } if (config.env === 'uat') {
    return ({
      Hello0028: VIP_BIZ.BIKE,
      'MAP-Hello0065': VIP_BIZ.TAXI,
      Hello0026: VIP_BIZ.HITCH,
      Hello0019: VIP_BIZ.TRAIN,
      Hello0258: VIP_BIZ.HOTEL,
      Hello0261: VIP_BIZ.SCENE,
      Hello0262: VIP_BIZ.RENT,
      Hello0181: VIP_BIZ.QUICK_SEND,
      Hello0281: VIP_BIZ.GAS,
      Hello0271: VIP_BIZ.GOODS,
      Hello0008: VIP_BIZ.BATTERY,
      Hello0048: VIP_BIZ.FINANCIAL, // 金融业务线
    })[v] || null;
  } if (config.env === 'pre' || config.env === 'pro') {
    return ({
      Hello0001: VIP_BIZ.BIKE,
      'MAP-Hello0065': VIP_BIZ.TAXI,
      Hello0006: VIP_BIZ.HITCH,
      Hello0011: VIP_BIZ.TRAIN,
      Hello0017: VIP_BIZ.HOTEL,
      Hello0020: VIP_BIZ.SCENE,
      Hello0021: VIP_BIZ.RENT,
      Hello0013: VIP_BIZ.QUICK_SEND,
      Hello0029: VIP_BIZ.GAS,
      Hello0028: VIP_BIZ.GOODS,
      Hello0003: VIP_BIZ.BATTERY,
      Hello0009: VIP_BIZ.FINANCIAL, // 金融业务线
    })[v] || null;
  }
  return null;
}

/**
 * 检查是否显示按钮
 * 判断是否是联名版会员，如果是微信小程序且是联名会员则不显示按钮
 * @returns {Promise<boolean>} 是否显示按钮
 */
export async function checkShowButton() {
  // 判断是否是联名版会员

  if (env.isWechatMini) {
    try {
      const { token, cityCode } = await getTokenAndLocation();
      const { data: { additionalGuid = '' } = {} } = await getBenifitsInReopen({
        token,
        systemCode: getSystemCode(),
        cityCode,
      });
      return !additionalGuid;
    } catch (error) {
      return true; // 出错时默认显示
    }
  }

  return true; // 非微信小程序默认显示
}

/**
 * 跳转到开卡完成页面
 * 根据当前URL参数获取重定向URL并跳转
 * @param {Object} options - 可选参数
 * @param {Array<string>} options.extraParams - 需要保留的额外URL参数名数组，必传参数会自动合并
 * @param {Object} options.fixedParams - 指定固定参数值的对象，优先级高于query参数，
 *   fixedParams中的参数会自动包含，无需在extraParams中重复声明
 * @returns {Promise<void>}
 */
export async function redirectToCardComplete(options = {}) {
  try {
  // 必传的默认参数
    const defaultExtraParams = ['tabCode', 'adsource', 'newH5Version'];
    const fixedParams = options.fixedParams || {};

    // 合并所有需要处理的参数：必传参数 + 额外参数 + fixedParams 中的参数
    const allParams = [
      ...defaultExtraParams,
      ...(options.extraParams || []),
      ...Object.keys(fixedParams),
    ];
    // 去重
    const extraParams = [...new Set(allParams)];

    const urlParams = ParamsUtil.getParams();
    const { token } = await getTokenAndLocation();

    const res = await getRedirectUrl({
      token,
    });
    if (res.data) {
      const timestamp = Date.now();
      const baseUrl = window.location.href.split('?')[0];
      const paramsToAdd = {
        isOpen: res.data.isOpen,
        timestamp,
      };

      // 添加需要保留的参数
      // 优先使用 fixedParams 中的固定值，如果没有则从 query 参数中获取
      extraParams.forEach((paramName) => {
        if (Object.prototype.hasOwnProperty.call(fixedParams, paramName)) {
          // 使用固定值（即使值为 null 或 undefined 也会使用）
          paramsToAdd[paramName] = fixedParams[paramName];
        } else if (urlParams[paramName]) {
          // 从 query 参数中获取
          paramsToAdd[paramName] = urlParams[paramName];
        }
      });

      const newUrl = ParamsUtil.addParams(baseUrl, paramsToAdd);
      console.log('🚀 ~ redirectToCardComplete ~ newUrl:', newUrl);

      if ((env.isEasyBikeApp && env.isIOS) || env.isWechatMini) {
        window.history.replaceState({}, '', newUrl);
        window.location.reload();
      } else if (env.isEasyBikeApp && env.isAndroid) {
        // 安卓的安全策略不支持reload 用以下方法
        Navigator.go(newUrl);
        Native.closeWebView();
      } else if (env.isAliMP || env.isAliMPMonitor) {
        let redirectUrl = res.data.redirectUrl || newUrl;
        // 处理链接：如果是 m2.hellobike，就处理成 m.hellobike；如果是 m.hellobike，就处理成 m2.hellobike
        if (redirectUrl.includes('m2.hellobike')) {
          redirectUrl = redirectUrl.replace(/m2\.hellobike/g, 'm.hellobike');
        } else if (redirectUrl.includes('m.hellobike')) {
          redirectUrl = redirectUrl.replace(/m\.hellobike/g, 'm2.hellobike');
        }
        window.location.replace(redirectUrl);
      } else {
        // 端外情况
        window.history.replaceState({}, '', newUrl);
        window.location.reload();
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}
